import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import usePutRequest from "../../../hooks/usePutReq";
import DropDown from "../../../components/dropDown";
import PaymentView from "./PaymentView";

// const mosjidName = process.env.REACT_APP_MOSJID_NAME;
// const mosjid_address = process.env.REACT_APP_MOSJID_ADDRESS;
// const email_address = process.env.REACT_APP_MOSJID_EMAIL_ADDRESS;
// const contact_number = process.env.REACT_APP_MOSJID_CONTACT_NUMBER;
const {
  REACT_APP_CLIENT_BASE_URL: clientURL,
  REACT_APP_MOSJID_NAME: mosjid_name,
  REACT_APP_MOSJID_DETAILS_NAME: mosjid_details_name,
  REACT_APP_MOSJID_ADDRESS: mosjid_address,
  REACT_APP_MOSJID_EMAIL_ADDRESS: email_address,
  REACT_APP_MOSJID_CONTACT_NUMBER: contact_number,
  REACT_APP_MOSJID_LOGO: mosjid_logo,
} = process.env;
const selectedOptions = ["View", "Resend"];

const PaymentAction = ({ payment }) => {
  const [selected, setSelected] = useState(selectedOptions[0]);
  const [isOpen, setIsOpen] = useState(false);
  const { data, onPutRequest } = usePutRequest();

  const { _id: paymentId, email, contactNumber } = payment || {};

  useEffect(() => {
    if (data) {
      toast.success(data?.message);
    }
  }, [data]);

  const selectedHandler = (value) => {
    if (value.toLowerCase() === "view") {
      setIsOpen(true);
    } else if (value.toLowerCase() === "resend") {
      if (!email) {
        toast.error("Email is not available!");
      } else {
        onPutRequest(
          `/payment/${mosjid_name}/again/receipt/sent/${paymentId}`,
          {
            email,
            contactNumber,
            pdfHeader: {
              mosjid_name,
              mosjid_details_name,
              mosjid_address,
              email_address,
              contact_number,
              mosjid_logo: clientURL + mosjid_logo,
            },
          }
        );
      }
    }
    setSelected(value);
  };

  const closeModal = () => {
    setIsOpen(false);
    setSelected(selectedOptions[0]);
  };

  return (
    <>
      <DropDown
        options={selectedOptions}
        selected={selected}
        setState={selectedHandler}
        fontSize="12px"
      />
      {isOpen && (
        <PaymentView
          isOpen={isOpen}
          closeModal={closeModal}
          paymentId={paymentId}
        />
      )}
    </>
  );
};

export default PaymentAction;
